import _defineProperty from "/builds/speachme/speachmeDesktop/speach-front/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/web.dom-exception.stack.js";
import "core-js/modules/web.structured-clone.js";
import { __decorate } from "tslib";
import { Component, Prop, Vue } from "vue-facing-decorator";
import axios from "axios";
import WElMessage from "@/components/wrappers/w-elmessage.vue";
import { Events } from "@/events/events";
import ItemsMatching from "@/components/itemsMatching/ItemsMatching.vue";
import quizUtils from "@/util/quizUtils";
import QuizUtils from "@/util/quizUtils";
let MatchingQuestionEdit = class MatchingQuestionEdit extends Vue {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "chapterId", void 0);
    _defineProperty(this, "questionId", void 0);
    _defineProperty(this, "question", null);
    _defineProperty(this, "matchingPairs", []);
  }
  mounted() {
    this.loadQuestionData();
  }
  /**
   * load question data by the questionId
   * @private
   */
  loadQuestionData() {
    axios.get(`${quizUtils.QUIZ_QUESTION_BASE_API}/${this.questionId}`, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(response => {
      this.handleLoadedMatchingData(response.data);
    }).catch(() => {
      WElMessage.showErrorMessage(this.$t('errors.default'));
    });
  }
  addPair(nbPair = 1) {
    for (let i = 0; i < nbPair; i++) {
      this.matchingPairs = [...this.matchingPairs, {
        position: this.matchingPairs.length + 1,
        item: '',
        itemResponse: ''
      }];
    }
  }
  /**
   * on matching update, save the data
   * @param pairs
   * @param activePair
   */
  onPairsUpdate(pairs, activePair) {
    this.matchingPairs = pairs;
    if ((!activePair || this.pairIsValid(activePair)) && this.atLeastTwoPairsItemsAreSet(pairs)) {
      this.saveMatchingPairs(pairs);
    }
  }
  /**
   * save pairs
   * @param pairs
   * @private
   */
  saveMatchingPairs(pairs) {
    const validPairs = this.getPairsToSave(pairs);
    if (validPairs.length) {
      axios.put(`${quizUtils.QUIZ_QUESTION_BASE_API}/${this.questionId}/matching-data`, {
        matchingPairsJson: JSON.stringify(validPairs)
      }, {
        headers: {
          'Content-Type': 'application/json'
        }
      }).then(response => {
        WElMessage.showSuccessMessage(this.$t('chapter.question.answerModification.success'));
        this.handleLoadedMatchingData(response.data);
        trig(Events.NEW_KIND_OF_QUESTION_UPDATED, {
          chapterId: this.chapterId,
          questionId: this.questionId
        });
      }).catch(() => {
        WElMessage.showErrorMessage(this.$t('errors.default'));
      });
    }
  }
  handleLoadedMatchingData(loadedQuestion) {
    this.question = loadedQuestion;
    if (!!this.question?.matchingPairs?.length) {
      this.matchingPairs = this.question.matchingPairs.map(pair => ({
        id: pair.id,
        position: pair.position,
        item: pair.item,
        itemImage: pair.itemImage,
        itemResponse: pair.itemResponse,
        itemResponseImage: pair.itemResponseImage
      }));
    } else {
      this.addPair(2);
    }
  }
  /**
   * Get extract pairs to save.
   * @param pairs
   * @private
   */
  getPairsToSave(pairs) {
    const validPairs = structuredClone(pairs).filter(pair => this.pairIsValid(pair));
    validPairs.sort((a, b) => a.position - b.position);
    validPairs.forEach((pair, index) => {
      pair.position = index + 1;
      delete pair.isItemError;
      delete pair.isItemResponseError;
    });
    return validPairs;
  }
  /**
   * verifier si au moins deux associations sont bien renseignées
   * @private
   */
  atLeastTwoPairsItemsAreSet(pairs) {
    return pairs.filter(pair => this.pairIsValid(pair)).length >= 2;
  }
  /**
   * verifier si une association est bien remplie
   * @param pair
   * @private
   */
  pairIsValid(pair) {
    return (!!pair.item || QuizUtils.questionAnswerImageExists(pair.itemImage)) && (!!pair.itemResponse || QuizUtils.questionAnswerImageExists(pair.itemResponseImage));
  }
};
__decorate([Prop({
  required: true
})], MatchingQuestionEdit.prototype, "chapterId", void 0);
__decorate([Prop({
  required: true
})], MatchingQuestionEdit.prototype, "questionId", void 0);
MatchingQuestionEdit = __decorate([Component({
  components: {
    ItemsMatching
  }
})], MatchingQuestionEdit);
export default MatchingQuestionEdit;